import { render, staticRenderFns } from "./p295_menu_mobile.vue?vue&type=template&id=61935c00"
import script from "./p295_menu_mobile.vue?vue&type=script&lang=js"
export * from "./p295_menu_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports